// extracted by mini-css-extract-plugin
export var infoItem = "_j0-1";
export var title = "_j0-0";